"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const spinner_1 = require("../spinner");
/**Vista del botón de bootstrap*/
class ButtonView extends React.PureComponent {
    render() {
        const style = this.props.style;
        const icon = this.props.iconClass;
        const content = this.props.children;
        const className = "btn btn-" +
            (style || "default") +
            (this.props.disabled ? " disabled" : "") +
            (this.props.block ? " btn-block" : "");
        return (React.createElement("button", { type: "button", className: className, title: this.props.tooltip, disabled: this.props.disabled || this.props.loading, onClick: this.props.onClick },
            this.props.loading ?
                React.createElement(spinner_1.Spinner, null) :
                (icon && React.createElement("i", { className: icon })),
            " ",
            content));
    }
}
exports.ButtonView = ButtonView;
/**Vista del botón de bootstrap*/
class LinkView extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.colors = {
            default: undefined,
            primary: "#26b",
            success: "#1a5",
            info: "#26b",
            warning: "#dd2",
            danger: "#d22",
            link: "#26b",
        };
    }
    render() {
        const styleColor = this.props.style;
        const icon = this.props.disabled ? "fa fa-ban fa-fw" : this.props.iconClass;
        const content = this.props.children;
        const style = { margin: 3, cursor: this.props.disabled ? "not-allowed" : "pointer", color: this.colors[styleColor || "default"] };
        return (React.createElement("a", { onClick: this.props.onClick, title: this.props.tooltip, style: style },
            this.props.loading ?
                React.createElement(spinner_1.Spinner, null) :
                (icon && React.createElement("i", { className: icon })),
            " ",
            content));
    }
}
exports.LinkView = LinkView;



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/botones/view.js
// module id = 2202
// module chunks = 0